/**
 * FlowNodeMCP.jsx
 * Enhanced Flow Node that uses the Model Context Protocol
 */
import React, { useEffect, useMemo, useRef } from 'react';
import { useFlowContext } from '../../contexts/FlowContext.jsx';
import FlowNode from './FlowNode';

function FlowNodeMCP({ hasBreakpoint, ...props }) {
  const { id, selected, data } = props;
  const { setCurrentNode, setVar } = useFlowContext();

  useEffect(() => {
    if (selected) {
      setCurrentNode(id);
    }
  }, [selected, id, setCurrentNode]);

  // Register all node stateVars in MCP context
  const stateVars = Array.isArray(data?.stateVars) ? data.stateVars : [];
  const stateVarsDep = stateVars.join('|');
  const lastStateVarsDep = useRef(stateVarsDep);
  useEffect(() => {
    if (setVar && stateVars.length > 0 && lastStateVarsDep.current !== stateVarsDep) {
      stateVars.forEach((key) => {
        setVar(key, data[key], 'node', id, {
          type: (data.stateVarTypes && data.stateVarTypes[key]) || 'string',
          description: (data.stateVarDescriptions && data.stateVarDescriptions[key]) || '',
          persistent: (data.stateVarPersistents && data.stateVarPersistents[key]) || false,
          updatedBy: 'user',
        });
      });
      lastStateVarsDep.current = stateVarsDep;
    }
  }, [id, setVar, stateVarsDep]);

  // Don't override the onClick handler - let FlowNode handle all events
  return <FlowNode {...props} hasBreakpoint={hasBreakpoint} />;
}

export default React.memo(FlowNodeMCP);
